import api from "./apiHelper";
import { queryCache } from "react-query";
import { useCustomPaginatedQuery, useCustomQuery } from "hooks/reactQuery";

export const postCreatePolicy = (payload) => {
  return api.post(`/policy`, payload);
};

export const useGetPoliciesForSuggestions = (name, onError) => {
  const getPolicies = async (key, name) => {
    return api.get(`/policy/name/${name}`);
  };
  return useCustomQuery("policiesForSuggestions", [name], getPolicies, {
    onError,
    shouldFetch: !!name,
  });
};

export const useGetPolicies = (query, onError) => {
  const getPolicies = async (key, query) => {
    return api.get(`/policy/aggregation`, {
      params: { ...query },
    });
  };
  return useCustomPaginatedQuery("policies", getPolicies, query, {
    onError,
  });
};

export const useGetPolicyDetails = (policyId, query, onError) => {
  const getPolicyDetails = async (key, policyId, query) => {
    return api.get(`/policy/${policyId}`, {
      params: { ...query },
    });
  };
  return useCustomQuery("policyDetails", [policyId, query], getPolicyDetails, {
    onError,
    shouldFetch: !!policyId,
  });
};

export const patchPolicy = (policyId, payload) => {
  return api.patch(`/policy/${policyId}`, payload);
};

export const deletePolicy = (policyId) => {
  return api.delete(`policy/${policyId}`);
};

export const uploadPolicy = (file, progress) => {
  return api.post(`policy/upload`, file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: progress,
  });
};

export const refetchPolicies = () => {
  queryCache.refetchQueries(["policies"]);
};

export const refetchPolicyDetails = (policyId) => {
  queryCache.refetchQueries(["policyDetails", policyId]);
};
